//#region IMPORT
import { useState, useEffect, useRef } from 'react';
/** Services Import */
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import { v4 as uuidv4 } from 'uuid';
import ExcelJS from 'exceljs';
/** Components */
import { DEP_BASIC } from './index';
import useDelete from '../../../../hooks/useDeleteN';
import useCheckDuplicate from '../../../../hooks/useCheckDuplicate';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import {
  setChanged,
  setDeleted,
  setRowData,
  setSelected,
} from '../../../../Reducer/GridReducer';
import { useSave } from '../../../../hooks/useSaveN';
import { createInitial } from '../../../../util';

import { DEP_BASIC_Schema } from './DEP_BASIC_Schema';
import { useDelete1, useSearch1, useSave1 } from './DEP_BASIC_QUERY';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'Department';
const COLUMN_KEYS = ['depNm1', 'depNm2', 'depNm3', 'depNm4'];
const HEADER_MAP = {
  본부: 'depNm1',
  부서: 'depNm2',
  팀: 'depNm3',
  파트: 'depNm4',
};
const COL_WIDTH = ['20%', '30%', '20%', '30%'];
//#endregion

function DEP_BASICF() {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((s) => s.SearchInfo);
  const { checkDuplicate } = useCheckDuplicate(); // 중복 KEY 체크 Hook

  // 유저정보 배열로 구성되어 있어 첫 번재 요소 가져오도록 사용함 후에 지워야 할 수도 있음

  //#region 그리드 변수
  const gridState1 = useSelector((state) => state.grid.grid1);
  const setRowData1 = (rows) =>
    dispatch(setRowData({ gridId: 'grid1', rowData: rows }));
  const setDeletedRowData1 = (rows) =>
    dispatch(setDeleted({ gridId: 'grid1', deleted: rows }));
  const setChangedRowData1 = (rows) =>
    dispatch(setChanged({ gridId: 'grid1', changed: rows }));
  const [inputs, setInputs] = useState(() => createInitial(DEP_BASIC_Schema));
  const gridRef1 = useRef(); //회사정보 그리드
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const inputRef = useRef(null); //추가 버튼 시 포커스

  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: gridState1.changed.filter((row) => !row.deleteYn),
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.depCd,
    getKeyFromResult: (result) => result.depCd,
  });

  const currentRowIndexRef = useRef(null);
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  const deleteDepartmentMutation = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    gridState: gridState1,
    deleteMutation: deleteDepartmentMutation,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    rowData: gridState1.rowData,
    setChangedRowData: setChangedRowData1,
  });

  const updateCurrentRowData = (fieldName, value, skipValidation = false) => {
    if (!gridRef1.current || currentRowIndexRef.current === null) return;

    const api = gridRef1.current.api;
    const rowNode = api.getDisplayedRowAtIndex(currentRowIndexRef.current);
    if (!rowNode) return;

    const prevData = rowNode.data;
    const updatedRowData = {
      ...prevData,
      [fieldName]: value,
      editYn: 'Y',
    };

    rowNode.setData(updatedRowData);

    if (
      !skipValidation &&
      (!updatedRowData.depNm1 || !updatedRowData.depNm1.trim())
    ) {
      return;
    }

    if (!Array.isArray(gridState1.changed)) return;

    const alreadyChangedIndex = gridState1.changed.findIndex(
      (item) => item.no === updatedRowData.no
    );
    const newChangedList = [...gridState1.changed];

    if (alreadyChangedIndex > -1) {
      newChangedList[alreadyChangedIndex] = updatedRowData;
    } else {
      newChangedList.push(updatedRowData);
    }

    dispatch(
      setChanged({
        gridId: 'grid1',
        changed: newChangedList,
      })
    );
  };

  const fileInputRef = useRef(null);

  const tableData = [
    {
      cells: [
        {
          gubun: 'R',
          content: '부서정보',
          colSpan: 4,
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '본부',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.depNm1 ? inputs.depNm1 : '',
          field: 'depNm1', // 필수
          isRequired: true, // 필수 입력 지정
          inputRef: inputRef,
          maxLength: 20,
          onChange: (e) => {
            const { name, value } = e.target;
            const updatedInputs = { ...inputs, [name]: value, newYn: 'Y' };
            setInputs(updatedInputs);
            updateCurrentRowData(name, value);
          },
        },
        {
          gubun: 'R',
          content: '부서',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.depNm2 ? inputs.depNm2 : '',
          field: 'depNm2', // 필수
          maxLength: 20,
          onChange: (e) => {
            const { name, value } = e.target;
            const updatedInputs = { ...inputs, [name]: value, newYn: 'Y' };
            setInputs(updatedInputs);
            updateCurrentRowData(name, value);
          },
        },
      ],
    },

    {
      cells: [
        {
          gubun: 'R',
          content: '팀',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.depNm3 ? inputs.depNm3 : '',
          field: 'depNm3', // 필수
          maxLength: 20,
          inputRef: inputRef,
          onChange: (e) => {
            const { name, value } = e.target;
            const updatedInputs = { ...inputs, [name]: value, newYn: 'Y' };
            setInputs(updatedInputs);
            updateCurrentRowData(name, value);
          },
        },
        {
          gubun: 'R',
          content: '파트',
        },
        {
          gubun: 'I',
          type: 'input',
          field: 'depNm4', // 필수
          maxLength: 20,
          value: inputs.depNm4 ? inputs.depNm4 : '',
          onChange: (e) => {
            const { name, value } = e.target;
            const updatedInputs = { ...inputs, [name]: value, newYn: 'Y' };
            setInputs(updatedInputs);
            updateCurrentRowData(name, value);
          },
        },
      ],
    },
  ];

  //#endregion

  //#region 조회

  const { refetch: Search1 } = useSearch1();

  useEffect(() => {
    const gridApi = gridRef1?.current?.api;

    if (gridApi && gridState1.rowData.length > 0) {
      const firstRowNode = gridApi.getDisplayedRowAtIndex(0);
      const firstRowData = firstRowNode?.data;

      gridApi.deselectAll(); // 기존 선택 해제
      gridApi.ensureIndexVisible(0, 'middle'); // 스크롤 이동
      gridApi.setFocusedCell(0, 'depNm1'); // 원하는 필드로 포커스

      if (firstRowData) {
        const copied = JSON.parse(JSON.stringify(firstRowData));
        handleRowSelection(copied, 0); // 👉 오른쪽 폼에 바인딩
        firstRowNode.setSelected(true, false);
      }
    }
  }, [gridState1.rowData]); // 👉 rowData가 채워지면 실행

  //#endregion

  //#region 저장
  //폼 상태값 리셋 함수 (useSave에서 사용하므로 먼저 정의)
  const ResetLogic = () => {
    setInputs(createInitial(DEP_BASIC_Schema));
    dispatch(setSelected({ gridId: 'grid1', selected: [] }));
    dispatch(setChanged({ gridId: 'grid1', changed: [] }));
    dispatch(setDeleted({ gridId: 'grid1', deleted: [] }));
  };

  const { runAsync: Save1Async } = useSave1();

  const makeParentDeps = (changedRows, existingRows) => {
    const existSet = new Set(
      existingRows.map((r) => `${r.depNm1}|${r.depNm2}|${r.depNm3}|${r.depNm4}`)
    );

    const makeRow = (nm1, nm2, nm3, nm4, isUserInput = false) => ({
      no: uuidv4(),
      depNm1: nm1 || '',
      depNm2: nm2 || '',
      depNm3: nm3 || '',
      depNm4: nm4 || '',
      depCd: isUserInput ? uuidv4() : '',
      newYn: 'Y',
    });

    let newRows = [];

    for (const row of changedRows) {
      const { depNm1, depNm2, depNm3, depNm4 } = row;
      if (depNm1 && !existSet.has(`${depNm1}|||`)) {
        newRows.push(makeRow(depNm1));
        existSet.add(`${depNm1}|||`);
      }
      if (depNm1 && depNm2 && !existSet.has(`${depNm1}|${depNm2}||`)) {
        newRows.push(makeRow(depNm1, depNm2));
        existSet.add(`${depNm1}|${depNm2}||`);
      }
      if (
        depNm1 &&
        depNm2 &&
        depNm3 &&
        !existSet.has(`${depNm1}|${depNm2}|${depNm3}|`)
      ) {
        newRows.push(makeRow(depNm1, depNm2, depNm3));
        existSet.add(`${depNm1}|${depNm2}|${depNm3}|`);
      }
      if (
        depNm1 &&
        depNm2 &&
        depNm3 &&
        depNm4 &&
        !existSet.has(`${depNm1}|${depNm2}|${depNm3}|${depNm4}`)
      ) {
        newRows.push(makeRow(depNm1, depNm2, depNm3, depNm4));
        existSet.add(`${depNm1}|${depNm2}|${depNm3}|${depNm4}`);
      }
    }

    return [...newRows];
  };

  const { run: SaveLogic1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '본부',
    schema: DEP_BASIC_Schema,
    getChangedRows: () => {
      const changedRows = gridState1.changed.filter((row) => !row.deleteYn);
      if (changedRows.length === 0) return [];

      let ensuredRows = makeParentDeps(
        changedRows.map((r) => ({ ...r, isUserInput: true })),
        gridState1.rowData
      );

      if (ensuredRows.length === 0) {
        dispatch(
          showSnackbar({
            message: '이미 등록된 데이터이거나 저장할 내용이 없습니다.',
            type: 'warning',
          })
        );
        return false;
      }

      return ensuredRows.map((row) => ({
        ...row,
        custCd: searchInfo.custCd,
      }));
    },
    getDeletedRows: () => gridState1.deleted,
    requestDelete: () => deleteHandler1.DeleteLogic(),
    requestSave: (rows) => {
      return Save1Async(rows);
    },
    refresh: Search1,
    reset: ResetLogic,
    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  //#endregion

  //#region 나머지 함수

  //추가 버튼 클릭 시 이벤트
  const HandleAddClick = async (_gridRef) => {
    dispatch(setSelected({ gridId: 'grid1', selected: [] }));
    if (_gridRef) {
      const api = _gridRef.current.api;
      inputRef.current?.focus();
      api.deselectAll();
      const newRow = {
        no: uuidv4(),
        depNm1: '', // 부서1
        depNm2: '', // 부서2
        depNm3: '', // 부서3
        depNm4: '', // 부서4
        newYn: 'Y', //필수값
      };
      _gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: 0,
      });

      const addedRowNode = _gridRef.current.api.getDisplayedRowAtIndex(0);
      if (addedRowNode) {
        setInputs(addedRowNode.data);
        currentRowIndexRef.current = 0;
        // addedRowNode.setSelected(true);
      }
    }
  };
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  //#endregion

  //#region 엑셀 업/다운
  const makeKeyString = (item) =>
    COLUMN_KEYS.map((k) => {
      const v = item[k];
      return v !== null && v !== undefined ? String(v).trim() : '';
    }).join('|');

  const isKeyEmpty = (key) => {
    if (key == null || key === '') return true;
    return key.split('|').every((p) => p.trim() === '');
  };

  /** 엑셀 업로드 */
  const ExcelUpload1 = async (file) => {
    try {
      dispatch(showLoading());

      const arrayBuffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '엑셀 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoading());
        return;
      }

      const headerRow = worksheet.getRow(1);
      const colCount = 4;
      const fieldKeys = [];
      for (let i = 1; i <= colCount; i++) {
        const cellVal = headerRow.getCell(i).value;
        const text =
          cellVal != null
            ? typeof cellVal === 'object' && cellVal.richText
              ? (cellVal.richText || []).map((t) => t?.text || '').join('')
              : String(cellVal).trim()
            : '';
        fieldKeys.push(HEADER_MAP[text] || `col${i}`);
      }

      const uploadedData = [];
      let rowIndex = 2;
      const maxRows = 2000;

      while (rowIndex <= maxRows) {
        const row = worksheet.getRow(rowIndex);
        const rowObj = {};
        let hasAny = false;
        for (let i = 0; i < fieldKeys.length; i++) {
          const cell = row.getCell(i + 1);
          let value = cell.value;
          if (value !== null && value !== undefined) {
            hasAny = true;
            if (typeof value === 'object' && value !== null && value.richText) {
              value = (value.richText || [])
                .map((t) => t?.text || '')
                .join('')
                .trim();
            } else {
              value = String(value).trim();
            }
          } else {
            value = '';
          }
          rowObj[fieldKeys[i]] = value;
        }
        if (!hasAny) break;

        const key = makeKeyString(rowObj);
        if (!isKeyEmpty(key)) {
          rowObj.no = rowObj.no || `new_${Date.now()}_${rowIndex}`;
          rowObj.newYn = 'Y';
          uploadedData.push(rowObj);
        }
        rowIndex++;
      }

      if (uploadedData.length === 0) {
        dispatch(
          showSnackbar({
            message: '읽을 수 있는 데이터가 없습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoading());
        return;
      }

      const existingDataMap = new Map();
      (gridState1.rowData || []).forEach((row) => {
        if (!row.deleteYn) {
          const key = makeKeyString(row);
          if (key) existingDataMap.set(key, row);
        }
      });

      const excelKeySet = new Set();
      uploadedData.forEach((row) => {
        const key = makeKeyString(row);
        if (key) excelKeySet.add(key);
      });

      const toStr = (v) =>
        v === undefined || v === null || v === '' ? '' : String(v).trim();
      const hasChanges = (existingRow, excelRow) => {
        for (const field of COLUMN_KEYS) {
          if (toStr(existingRow[field]) !== toStr(excelRow[field])) return true;
        }
        return false;
      };

      const newRows = [];
      const updatedRows = [];
      const updatedKeys = new Set();

      for (const excelRow of uploadedData) {
        const key = makeKeyString(excelRow);
        if (!key) continue;

        if (existingDataMap.has(key)) {
          const existingRow = existingDataMap.get(key);
          if (hasChanges(existingRow, excelRow)) {
            updatedRows.push({
              ...existingRow,
              ...excelRow,
              editYn: 'Y',
              no: existingRow.no,
              depCd: existingRow.depCd ?? '',
            });
            updatedKeys.add(key);
          }
        } else {
          newRows.push({
            ...excelRow,
            newYn: 'Y',
            no: excelRow.no || `new_${Date.now()}_${Math.random()}`,
          });
        }
      }

      const rowsToDelete = [];
      (gridState1.rowData || []).forEach((row) => {
        if (!row.deleteYn) {
          const key = makeKeyString(row);
          if (key && !excelKeySet.has(key)) {
            rowsToDelete.push({ ...row, deleteYn: 'Y' });
          }
        }
      });

      const updatedRowData = (gridState1.rowData || []).map((row) => {
        if (row.deleteYn) return row;
        const key = makeKeyString(row);
        if (key && updatedKeys.has(key)) {
          const updated = updatedRows.find((r) => makeKeyString(r) === key);
          if (updated) return updated;
        }
        if (rowsToDelete.some((rd) => rd.no === row.no)) {
          return { ...row, deleteYn: 'Y' };
        }
        return row;
      });

      const finalRowData = [...updatedRowData, ...newRows];
      // setRowData1(finalRowData);
      if (gridRef1.current?.api) {
        gridRef1.current.api.setRowData(finalRowData);
      }
      setChangedRowData1(
        finalRowData.filter((row) => row.newYn === 'Y' || row.editYn === 'Y')
      );
      if (rowsToDelete.length > 0) {
        const existingDeleted = Array.isArray(gridState1.deleted)
          ? gridState1.deleted
          : [];
        const added = rowsToDelete.filter(
          (rd) => !existingDeleted.some((ed) => ed.no === rd.no)
        );
        setDeletedRowData1([...existingDeleted, ...added]);
      }

      dispatch(
        showSnackbar({
          message: '엑셀 업로드가 완료되었습니다.',
          type: 'success',
        })
      );
    } catch (error) {
      console.error('Excel upload error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 업로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  /** 엑셀 다운로드 */
  const ExcelDownload1 = async () => {
    try {
      dispatch(showLoading());

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('부서정보', {
        views: [{ state: 'frozen', ySplit: 1 }],
      });

      const headers = ['본부', '부서', '팀', '파트'];
      const headerRow = sheet.getRow(1);
      headers.forEach((h, i) => {
        headerRow.getCell(i + 1).value = h;
        headerRow.getCell(i + 1).font = { bold: true };
      });
      headerRow.commit();

      const detailData = (gridState1.rowData || []).filter((r) => !r.deleteYn);
      detailData.forEach((item, index) => {
        const row = sheet.getRow(2 + index);
        COLUMN_KEYS.forEach((key, i) => {
          const cell = row.getCell(i + 1);
          cell.value = item[key] ?? '';
          cell.font = { name: '맑은 고딕', size: 10 };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
            wrapText: false,
          };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF808080' } },
            left: { style: 'thin', color: { argb: 'FF808080' } },
            bottom: { style: 'thin', color: { argb: 'FF808080' } },
            right: { style: 'thin', color: { argb: 'FF808080' } },
          };
        });
        row.commit();
      });

      const now = new Date();
      const dateTimeStr =
        `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_` +
        `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
      const fileName = `부서관리_${dateTimeStr}.xlsx`;

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);

      dispatch(closeLoading());
      dispatch(
        showSnackbar({
          message: '엑셀 다운로드가 완료되었습니다.',
          type: 'success',
        })
      );
    } catch (error) {
      console.error('Excel download error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 다운로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
      dispatch(closeLoading());
    }
  };
  //#endregion

  const handleRowSelection = async (rowData, rowIndex) => {
    setInputs({ ...rowData });
    currentRowIndexRef.current = rowIndex;
  };

  return (
    <div className="wrap">
      <DEP_BASIC
        gridId1={'grid1'}
        userInfo={userInfo}
        inputs={inputs}
        setInputs={setInputs}
        rowData={gridState1.rowData}
        selectedRowData={gridState1.selected}
        delectedRowData={gridState1.deleted}
        changedRowData={gridState1.changed}
        setSelectedRowData={(sel) =>
          dispatch(setSelected({ gridId: 'grid1', selected: sel }))
        }
        setChangedRowData={(sel) =>
          dispatch(setChanged({ gridId: 'grid1', changed: sel }))
        }
        setDeletedRowData={(sel) =>
          dispatch(setDeleted({ gridId: 'grid1', deleted: sel }))
        }
        colWidth={COL_WIDTH}
        tableData={tableData}
        gridRef1={gridRef1}
        inputRef={inputRef}
        fileInputRef={fileInputRef}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        // 함수
        SearchLogic1={Search1}
        SaveLogic1={SaveLogic1}
        HandleAddClick={HandleAddClick}
        ResetLogic={ResetLogic}
        NewYnErrorMsg={NewYnErrorMsg}
        ExcelUpload1={ExcelUpload1}
        ExcelDownload1={ExcelDownload1}
        handleRowSelection={handleRowSelection}
        MarkedForDeletion={deleteHandler1.MarkedForDeletion}
        RestoreRow={deleteHandler1.RestoreRow}
        updateCurrentRowData={updateCurrentRowData}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        gridState={gridState1}
        dispatchGrid={dispatch}
      />
    </div>
  );
}

export default DEP_BASICF;
